// Namespace "admin" — fragment "validationSweep".
//
// Keys introduced while wiring the save-validation recipe (lib/validation.js) into the
// remainder of the admin plane (settings/billing/payments/social/automation/branding,
// TaxAdmin, the two wizards, MessagesAdmin). Each key is owned by exactly one schema
// below — see the call site for the backend rule it mirrors:
//   · customDomain.invalidFormat — tenant_self_service.py's DOMAIN_RE, shared by
//     CustomDomainAdmin.jsx and SiteBuilderWizard.jsx's address step (same format rule,
//     two forms — one key, not two).
//   · auto.nameTooShort / auto.nameTooLong — modules/automation.py AutomationRuleIn.name
//     (Field(..., min_length=2, max_length=120)). Both live in THIS namespace, unlike the
//     shared lib/validation.js pair, because the name field's error is resolved through
//     the admin `t` binding, not `tc` — a schema must not mix namespaces on one field, or
//     whichever message the caller resolves through the wrong `t` silently misses.
//   · social.scheduledAtRequired — modules/social.py create_post's 400 when
//     status="scheduled" and scheduled_at is empty.
//   · tax.rateOutOfRange — platform_settings_routes.py's TaxLine rate bound (0-100),
//     enforced today only after a round trip; this stops the round trip.
export default {
  fr: {
    "customDomain.invalidFormat": "Indiquez un domaine valide, par exemple clinic.example.com.",
    "auto.nameTooShort": "Le nom doit comporter au moins 2 caractères.",
    "auto.nameTooLong": "Le nom est trop long (120 caractères maximum).",
    "social.scheduledAtRequired": "Choisissez une date et une heure pour programmer cette publication.",
    "tax.rateOutOfRange": "Indiquez un taux entre 0 et 100.",
  },
  en: {
    "customDomain.invalidFormat": "Enter a valid domain, like clinic.example.com.",
    "auto.nameTooShort": "Name must be at least 2 characters.",
    "auto.nameTooLong": "Name is too long (120 characters max).",
    "social.scheduledAtRequired": "Pick a date and time to schedule this post.",
    "tax.rateOutOfRange": "Enter a rate between 0 and 100.",
  },
  es: {
    "customDomain.invalidFormat": "Indica un dominio válido, por ejemplo clinic.example.com.",
    "auto.nameTooShort": "El nombre debe tener al menos 2 caracteres.",
    "auto.nameTooLong": "El nombre es demasiado largo (máximo 120 caracteres).",
    "social.scheduledAtRequired": "Elige una fecha y hora para programar esta publicación.",
    "tax.rateOutOfRange": "Indica una tasa entre 0 y 100.",
  },
};
